import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { HelpersService } from './helpers.service';

@Injectable({
  providedIn: 'root',
})
export class UploadService {
  private url = HelpersService.api('uploads');

  constructor(private router: Router, private httpClient: HttpClient) {}

  public uploadImageFiles(input: any): Observable<any> {
    return this.httpClient.post(this.url + '/s3', input);
  }
  public deleteImageFiles(input: any): Observable<any> {
    return this.httpClient.delete(this.url + '/' + input);
  }
  public uploadVideoFiles(input: any): Observable<any> {
    return this.httpClient.post(this.url + '/s3/upload-queue', input);
  }
  public sendUserEmail(input: any): Observable<any> {
    return this.httpClient.post(this.url + '/user-sendmail', input);
  }
  public sendAdminEmail(input: any): Observable<any> {
    return this.httpClient.post(this.url + '/admin-sendmail', input);
  }
}
